import { Box, styled } from '@mui/material';

/**
 * Challenge-only. The layout both MFA screens share lives in `src/modules/auth/mfa-styles.ts`.
 */

/**
 * The switch between the two inputs, in both directions — "Use a backup code instead" on the
 * authenticator view, "Use your authenticator app instead" on the backup-code one.
 *
 * A real `<button>`, not text with an onClick: it is a real control now (US 94 gave it an endpoint),
 * and the element gets focus, Enter/Space and a screen-reader role for free. Styled from the raw tag
 * rather than from `Typography component="button"` because MUI's `styled()` drops the polymorphic
 * `component` prop from the resulting type. The resets below undo the browser's button chrome so it
 * still reads as a link.
 */
export const MfaBackupCodeAction = styled('button')(({ theme }) => ({
  fontSize: '13px',
  fontFamily: 'inherit',
  textAlign: 'center',
  color: theme.palette.secondary.main,
  cursor: 'pointer',
  textDecoration: 'underline',
  background: 'none',
  border: 'none',
  padding: 0,
  '&:hover': {
    color: theme.palette.secondary.contrastText,
  },
  '&:disabled': {
    cursor: 'default',
    textDecoration: 'none',
    opacity: 0.6,
  },
}));

/**
 * The count line on the success notice. Warning-coloured because the user has just spent a finite,
 * unreplaceable resource — there is no endpoint to issue new codes.
 */
export const MfaBackupCodesRemaining = styled(Box)(({ theme }) => ({
  fontSize: '13px',
  textAlign: 'center',
  color: theme.palette.warning.main,
}));

/** The zero case: the same line, escalated, because the next lost authenticator locks them out. */
export const MfaBackupCodesExhausted = styled(MfaBackupCodesRemaining)(({ theme }) => ({
  color: theme.palette.error.main,
  fontWeight: 600,
}));
